// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Spqy","consentsList":"PatientConsents_consentsList__36zsq","consentsListEmpty":"PatientConsents_consentsListEmpty__3P5TO"};